import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'


const Bijgebouw = () => {
    return (
      <div className="bg-gray-white border-0 mt-32 lg:mt-0 font-inter">
        <div className=" flex flex-row justify-center items-center bg-gray-white mb-16  lg:mx-64">
          <div className="relative">
            <StaticImage
              src="https://res.cloudinary.com/yungnuts/image/upload/v1643545534/CVT/WEB3_dtivle.jpg"
              alt="Mooie foto"
              className=" max-h-screen"
            />
            <div className="hidden lg:block absolute right-0 bottom-0 bg-blue-effect  p-8 px-16 text-gray-white">
              <div className="font-semibold ">Kantoor Opwijk</div>
              <div>Schoolstraat 27</div>
              <div>1745 Opwijk</div>
            </div>
          </div>
        </div>

        <div className="lg:hidden flex flex-row justify-center ">
          <div className="flex-col justify-center items-center w-64 text-center  bg-blue-effect  p-8 px-16 text-gray-white">
            <div className="font-semibold ">Kantoor Opwijk</div>
            <div>Schoolstraat 27</div>
            <div>1745 Opwijk</div>
          </div>
        </div>
      </div>
    );
}

export default Bijgebouw
